var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8376 10.9416C15.9793 11.7166 16.7793 12.7666 16.7793 14.1666V16.6666H20.1126V14.1666C20.1126 12.3499 17.1376 11.2749 14.8376 10.9416ZM13.446 9.99992C15.2876 9.99992 16.7793 8.50825 16.7793 6.66659C16.7793 4.82492 15.2876 3.33325 13.446 3.33325C13.0543 3.33325 12.6876 3.41659 12.3376 3.53325C13.0547 4.4201 13.4459 5.52609 13.4459 6.66659C13.4459 7.80708 13.0547 8.91307 12.3376 9.79992C12.6876 9.91659 13.0543 9.99992 13.446 9.99992ZM8.44596 9.99992C10.2876 9.99992 11.7793 8.50825 11.7793 6.66659C11.7793 4.82492 10.2876 3.33325 8.44596 3.33325C6.6043 3.33325 5.11263 4.82492 5.11263 6.66659C5.11263 8.50825 6.6043 9.99992 8.44596 9.99992ZM8.44596 4.99992C9.36263 4.99992 10.1126 5.74992 10.1126 6.66659C10.1126 7.58325 9.36263 8.33325 8.44596 8.33325C7.5293 8.33325 6.7793 7.58325 6.7793 6.66659C6.7793 5.74992 7.5293 4.99992 8.44596 4.99992ZM8.44596 10.8333C6.22096 10.8333 1.7793 11.9499 1.7793 14.1666V16.6666H15.1126V14.1666C15.1126 11.9499 10.671 10.8333 8.44596 10.8333ZM13.446 14.9999H3.44596V14.1749C3.61263 13.5749 6.19596 12.4999 8.44596 12.4999C10.696 12.4999 13.2793 13.5749 13.446 14.1666V14.9999Z",
    fill: "#111B23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.b75f987c60f236f40196dab67a2a1528.svg";
export { ForwardRef as ReactComponent };